import { defineMessages } from 'react-intl'

import { ORDER_STATUS } from './constants'

export const orderStatusMessages = defineMessages({
  [ORDER_STATUS.CREATED]: {
    id: 'spanish.order.status.created',
    defaultMessage: 'Creado'
  },
  [ORDER_STATUS.PENDING]: {
    id: 'spanish.order.status.pending',
    defaultMessage: 'Pendiente'
  },
  [ORDER_STATUS.RECEIVED]: {
    id: 'spanish.order.status.received',
    defaultMessage: 'Recibido'
  },
  [ORDER_STATUS.COMPLETED]: {
    id: 'spanish.order.status.completed',
    defaultMessage: 'Completo'
  },
  [ORDER_STATUS.CANCELLED]: {
    id: 'spanish.order.status.cancelled',
    defaultMessage: 'Cancelado'
  },
  [ORDER_STATUS.REJECTED]: {
    id: 'spanish.order.status.rejected',
    defaultMessage: 'Rechazado'
  }
})
